// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___ToOy","clinicsSelect":"styles_clinicsSelect__3iw-I"};